<template>
    <card>
        <template v-slot:header>Gästebuchungen</template>

        <p v-show="schedules.length === 0">Keine Gästebuchungen.</p>

        <tailwind-table v-show="schedules.length > 0" :header="['Schreibtisch', 'Zeit', 'Notiz', '']">
            <tr v-for="schedule in schedules">
                <td class="px-6 py-3">{{ schedule.desk.name }}</td>
                <td class="px-6 py-3">{{ schedule.from.slice(10,16) }} - {{ schedule.to.slice(10,16) }}</td>
                <td class="px-6 py-3">{{ schedule.note }}</td>
            </tr>
        </tailwind-table>
    </card>
</template>

<script>
import Card from "./UI/Card";
import TailwindTable from "./UI/TailwindTable.vue"

export default {
    name: "GuestBookings",
    components: {Card, TailwindTable},

    props: ['schedules'],

}
</script>

<style>

</style>